var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLandscape = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 37,
    viewBox: "0 0 21 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.25l-6.563-13.125h3.938L11.314.63c-.095-.372-.43-.632-.814-.632-.384 0-.719.26-.814.632L2.625 13.125h3.938L0 26.25h8.531v10.5h3.938v-10.5H21z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLandscape, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/landscape.cb1db9b1.svg";
export { ForwardRef as ReactComponent };